'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _every2 = require('./internal/_every');

var _every3 = _interopRequireDefault(_every2);

var _get2 = require('./internal/_get');

var _get3 = _interopRequireDefault(_get2);

var _has2 = require('./internal/_has');

var _has3 = _interopRequireDefault(_has2);

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function match(pattern, candidate) {
  return (0, _every3.default)(function (val, key) {
    return (0, _has3.default)(key, candidate) && (0, _immutable.is)(val, (0, _get3.default)(key, candidate));
  }, pattern);
}

/**
 * Returns `true` if the key => value pairs in `pattern` match the correspoding key => value pairs in `subject`.
 *
 * @example
 * const hasOneAndThree = match({one: 1, three: 3});
 * hasOneAndThree(Map({one: 1, two: 2, three: 3})) === true;
 *
 * @param {Array|Iterable|Object} pattern
 * @param {Array|Iterable|Object} subject
 * @return {boolean}
 */
exports.default = (0, _curry2.default)(match);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/match.js
// module id = 186
// module chunks = 0 1